module.exports = __webpack_public_path__ + "img/location-confirm.7914394e.png";